<template>
  <div id="Setdepartment" class="Setdepartment CommonContentSingle-gray">
    <div id="Setdepartment-top1" class="Setdepartment-top1">
      <h2>预约咨询统计</h2>
      <ul>
        <li>
          <h3>{{ datas.AppointmentCount }}</h3>
          <p>总预约人次</p>
        </li>
        <li>
          <h3>{{ datas.Tobeconsulted }}</h3>
          <p>待咨询</p>
        </li>
        <li>
          <h3>{{ datas.NonArrival }}</h3>
          <p>来访未到</p>
        </li>
        <li>
          <h3>{{ datas.Complete }}</h3>
          <p>已完成</p>
        </li>
        <li>
          <h3>{{ datas.ZxCancel }}</h3>
          <p>咨询师取消</p>
        </li>
        <li>
          <h3>{{ datas.YuCancel }}</h3>
          <p>来访者取消</p>
        </li>
      </ul>
    </div>

    <div id="Setdepartment-top2" class="Setdepartment-top2">
      <div ref="myechart3" style="width: 100%; height: 100%;"></div>

      <!-- <ul>
        <li>
          <i style="background-color: rgba(0, 116, 199, 1);"></i>
          <span v-if="datas.Tobeconsulted == 0">
            {{ datas.Tobeconsulted }}人 | -
          </span>
          <span v-else>
            {{ datas.Tobeconsulted }}人 |
            {{((datas.Tobeconsulted / datas.AppointmentCount) * 100).toFixed(2)}}%
          </span>
          <em>待咨询 1111</em>
        </li>
        <li>
          <i style="background-color: rgba(0, 186, 173, 1);"></i>
          <span v-if="datas.NonArrival == 0">{{ datas.NonArrival }}人 | -</span>
          <span v-else>
            {{ datas.NonArrival }}人 |
            {{((datas.NonArrival / datas.AppointmentCount) * 100).toFixed(2)}}%
          </span>
          <em>来访者未到</em>
        </li>
        <li>
          <i style="background-color: rgba(224, 191, 101, 1);"></i>
          <span v-if="datas.Complete == 0">{{ datas.Complete }}人 | -</span>
          <span v-else>
            {{ datas.Complete }}人 |
            {{ ((datas.Complete / datas.AppointmentCount) * 100).toFixed(2) }}%
          </span>
          <br />
          <em>已完成</em>
        </li>
      </ul> -->
    </div>

    <div id="Setdepartment-top3" class="Setdepartment-top3">
      <h2>常用功能</h2>
      <ul>
        <li @click="Gourl('/Consultant/AppointmentList')">
          <div class="el-icon-s-custom" style="background: linear-gradient(135deg,rgba(46, 171, 255, 1) 0%,rgba(0, 136, 255, 1) 100%);"></div>
          <p>预约处理</p>
        </li>
        <li @click="Gourl('/CounselorLeave/ConsultingBlacklist')">
          <div class="el-icon-s-check" style="background: linear-gradient(135deg,rgba(255, 188, 64, 1) 0%,rgba(252, 140, 28, 1) 100%);"></div>
          <p>申请审批</p>
        </li>
        <li @click="Gourl('/measurement/Originaldata')">
          <div class="el-icon-s-data" style="background: linear-gradient(135deg,rgba(84, 214, 153, 1) 0%,rgba(40, 181, 115, 1) 100%);"></div>
          <p>数据统计</p>
        </li>
        <li @click="Gourl('/visitors/Already_ltest')">
          <div class="el-icon-document-copy" style="background: linear-gradient(135deg,rgba(255, 188, 64, 1) 0%,rgba(252, 140, 28, 1) 100%);"></div>
          <p>测试情况</p>
        </li>
        <li @click="Gourl('/measurement/Published')">
          <div class="el-icon-s-promotion" style="background: linear-gradient(135deg,rgba(46, 171, 255, 1) 0%,rgba(0, 136, 255, 1) 100%);"></div>
          <p>发布测评</p>
        </li>
        <li @click="Gourl('/measurement/Originaldata')">
          <div class="el-icon-upload" style="background: linear-gradient(135deg,rgba(84, 214, 153, 1) 0%,rgba(40, 181, 115, 1) 100%);"></div>
          <p>原始数据导出</p>
        </li>

        
      </ul>
    </div>
    
    <div id="Setdepartment-top4" class="Setdepartment-top4">
      <div class="cdsnhli">
        <h2>测评情况</h2>
        <span>更新时间： {{ times }}</span>
      </div>
      <ul>
        <li>
          <span>累积人数</span>
          <h3>{{ datas2.EvaluationCount }}</h3>
          <p>累积测评人次</p>
        </li>
        <li>
          <span></span>
          <h3>{{ datas2.EarlyWarning }}</h3>
          <p>累积预警人次</p>
        </li>
        <li>
          <span>今日数据</span>
          <h3>{{ datas2.Evaluations }}</h3>
          <p>今日测评人次</p>
        </li>
        <li>
          <span></span>
          <h3>{{ datas2.WarningJr }}</h3>
          <p>今日预警人次</p>
        </li>
      </ul>

      <div class="Setdepartment-top4left">
        <div ref="myechart" style="width: 600px; height: 230px;"></div>
      </div>

      <div class="Setdepartment-top4right">
        <div ref="myechart2" style="width: 215px; height: 231px;"></div>
      </div>
    </div>

    <div id="Setdepartment-top5" class="Setdepartment-top5">
      <h2>审批待办</h2>
      <ul>
        <li @click="HandleMenuClick('qj')">
          <div class="el-icon-tickets">
            <i v-if="!noteList.qj == 0">{{ noteList.qj }}</i>
          </div>
          <p>请假审批</p>
        </li>

        <li @click="HandleMenuClick('qxyy')">
          <div class="el-icon-data-analysis" style="background: linear-gradient(90deg,rgba(40, 181, 115, 1) 0%,rgba(77, 191, 138, 1) 100%);">
            <i v-if="!noteList.qxyy == 0">{{ noteList.qxyy }}</i>
          </div>
          <p>预约取消审批</p>
        </li>

        <li @click="HandleMenuClick('jj')">
          <div class="el-icon-first-aid-kit" style="background: linear-gradient(135deg,rgba(120, 139, 231, 1) 0%,rgba(92, 114, 226, 1) 100%);">
            <i v-if="!noteList.jj == 0">{{ noteList.jj }}</i>
          </div>
          <p>解禁审批</p>
        </li>

        <li @click="HandleMenuClick('cqzx')">
          <div class="el-icon-odometer"  style="background: linear-gradient(135deg,rgba(52, 171, 250, 1) 0%,rgba(0, 129, 233, 1) 100%);">
            <i v-if="!noteList.cqzx == 0">{{ noteList.cqzx }}</i>
          </div>
          <p>长期咨询审批</p>
        </li>

        <li @click="HandleMenuClick('hmd')">
          <div class="el-icon-data-analysis" style="background:linear-gradient(135deg,rgba(130, 101, 119, 1) 0%,rgba(106, 68, 89, 1) 100%);">
            <i v-if="!noteList.hmd == 0">{{ noteList.hmd }}</i>
          </div>
          <p>黑名单审批</p>
        </li>

        <li @click="HandleMenuClick('bgqx')">
          <div class="el-icon-view" style="background: linear-gradient(135deg,rgb(236, 203, 152) 0%,rgb(83, 9, 126) 100%);">
            <i v-if="!noteList.bgqx == 0">{{ noteList.bgqx }}</i>
          </div>
          <p>报告权限</p>
        </li>

        <li @click="HandleMenuClick('zxgly')" style="border-top:1px solid #c5c5c5;border-top:1px solid #c5c5c5">
          <div class="el-icon-star-off" style="background: linear-gradient(135deg, rgb(116 195 130) 0%, rgb(194 150 219) 100%);">
            <i v-if="!noteList.zxgly == 0">{{ noteList.zxgly }}</i>
          </div>
          <p>危机上报</p>
        </li>

        <li style="border-top:1px solid #c5c5c5;border-top:1px solid #c5c5c5"></li>
      </ul>
    </div>
  </div>
</template>
<script>
import ConsultingFilesVue from '../Consultant/ConsultingFiles.vue'

export default {
  data() {
    return {
      noteList: '',
      datas: '',
      datas2: '',
      times: '',
      data3: [],
      // Tobeconsultedb:'',
      // NonArrivalb:'',
      // Completeb:'',
    }
  },
  methods: {
    Gourl(val) {
      this.$router.push(val)
    },
    handleChange(value) {},
    HandleMenuClick(res) {
      if (res == 'qj') {//请假
        this.$router.push({path: '/Admin/ExamineLeave',})
      } else if (res == 'qxyy') {//预约取消审批
        this.$router.push({ path: '/Admin/ExamineAppointment',})
      } else if (res == 'jj') {//解禁审批
        this.$router.push({ path: '/Admin/ExamineBan',})
      } else if (res == 'cqzx') {//长期咨询审批
        this.$router.push({ path: '/Admin/ExamineLongConsult',})
      } else if (res == 'hmd') {//黑名单审批
        this.$router.push({ path: '/Admin/ExamineBlackList',})
      } else if (res == 'bgqx') {//报告权限
        this.$router.push({ path: '/Admin/ExamineConsultReport',})
      }else if (res == 'zxgly') {//报告权限
        this.$router.push({ path: '/Crisis/Crisis_upreport',})
      }
    },
    setChart() {
      var myChart = this.$echarts.init(this.$refs.myechart) // 指定图表的配置项和数据
      var option = {
        title: {
          text: '危机预警',
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow', // 'shadow' as default; can also be 'line' or 'shadow'
          },
        },
        legend: {},
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          data: ['SCL-90', '16PF', 'EPQA', 'PHI', 'SDS', 'SAS'],
        },
        yAxis: {
          type: 'value',
        },
        series: [
          {
            name: '正常',
            type: 'bar',
            stack: 'total',
            color: 'rgba(29, 154, 255, 1)',
            emphasis: {
              focus: 'series',
            },
            data: this.datas2.GreenYz,
          },
          {
            name: '轻',
            type: 'bar',
            stack: 'total',
            color: 'rgba(58, 194, 130, 1)',
            emphasis: {
              focus: 'series',
            },
            data: this.datas2.GreenYellowYz,
          },
          {
            name: '中',
            type: 'bar',
            stack: 'total',
            color: 'rgba(255, 196, 0, 1)',
            emphasis: {
              focus: 'series',
            },
            data: this.datas2.YellowYz,
          },
          {
            name: '较重',
            color: 'rgba(252, 111, 68, 1)',
            type: 'bar',
            stack: 'total',
            emphasis: {
              focus: 'series',
            },
            data: this.datas2.OrangeYz,
          },
          {
            name: '严重',
            color: 'rgba(194, 13, 4, 1)',
            type: 'bar',
            stack: 'total',
            emphasis: {
              focus: 'series',
            },
            data: this.datas2.RedYz,
          },
        ],
      }
      //使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },
    setChart2() {
      var myCharts = this.$echarts.init(this.$refs.myechart2) // 指定图表的配置项和数据
      var option2 = {
        tooltip: {
          trigger: 'item',
        },
        legend: {
          top: '5%',
          left: 'center',
        },
        series: [
          {
            type: 'pie',
            radius: ['40%', '70%'],
            label: {
              show: false,
              position: 'center',
            },
            color: ['rgba(237, 104, 104, 1)', 'rgba(0, 186, 173, 1)'],
            labelLine: {
              show: false,
            },
            data: [
              { value: this.datas2.EarlyWarning, name: '预警总人次' },
              { value: this.datas2.EvaluationCount, name: '测评总人数' },
            ],
          },
        ],
      }
      // 使用刚指定的配置项和数据显示图表。
      myCharts.setOption(option2)
    },
    setChart3() {

      var myCharts = this.$echarts.init(this.$refs.myechart3); //指定图表的配置项和数据

      var option3 = {
          tooltip: {
            trigger: 'item',
            // position: 'right'
          },
          legend: {
            left: 'center',
          },

          series: [
            {
              name: '类型',
              type: 'pie',
              radius: ['45%', '70%'],
              avoidLabelOverlap: false,
              label: {
                show: false,
                position: 'center'
              },
              emphasis: {
                label: {
                  show: true,
                  fontSize: 16,
                  fontWeight: 'bold'
                }
              },
              labelLine: {
                show: false
              },
              data: [
                { value: this.datas.Tobeconsulted, name: '待咨询',itemStyle: {color:'rgba(0, 116, 199, 1)'}},
                { value: this.datas.NonArrival, name: '来访未到', itemStyle:{color:'rgba(224, 191, 101, 1)'}},
                { value: this.datas.Complete, name: '已完成',     itemStyle:{color:'rgba(0, 186, 173, 1)'}},
                { value: this.datas.ZxCancel, name: '咨询师取消', itemStyle:{color:'rgba(222, 93, 93, 1)'}},
                { value: this.datas.YuCancel, name: '来访者取消' ,itemStyle:{color:'rgba(196, 196, 196, 1)'}}
              ]
            }
          ]
        };

      // 使用刚指定的配置项和数据显示图表。
      myCharts.setOption(option3);
    },


  },
  mounted() {
    var myDate = new Date()

    this.times = new Date(new Date() + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
    if (document.body.clientWidth < 1400) {
      document.getElementById('Setdepartment-top4').style.width = '100%'
      document.getElementById('Setdepartment-top1').style.width = '100%'
      document.getElementById('Setdepartment-top3').style.width = '100%'
      document.getElementById('Setdepartment-top2').style.display = 'none'
      document.getElementById('Setdepartment-top5').style.display = 'none'
    }

    this.$Http_Post('ConsultSubscribe/GetExamineItemCount').then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.noteList = res.Data;
      }
    })

    this.$Http_Post('ConsultSubscribe/AppointmentStatistics').then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.datas = res.Data;
        this.data3.push(
          parseFloat((Number(res.Data.Tobeconsulted)  / Number(res.Data.AppointmentCount) ) * 100,).toFixed(2),
        )
        this.data3.push(
          parseFloat((Number(res.Data.NonArrival) / Number(res.Data.AppointmentCount)) * 100,).toFixed(2),
        )
        this.data3.push(
          parseFloat((Number(res.Data.Complete) / Number(res.Data.AppointmentCount)) * 100,).toFixed(2),
        )
      }
    })

    this.$Http_Post('ConsultSubscribe/EvaluationSituation').then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.datas2 = res.Data
      }
    })

  },


  updated() {
    this.setChart()
    this.setChart2()
    this.setChart3()
  },

}
</script>
<style scoped>
.Setdepartment h2 {padding: 16px;font-size: 20px;}
.Setdepartment h3 {color: rgba(0, 136, 255, 1);font-size: 28px;margin-left: 16px;margin-top: 20px;}
.Setdepartment-top1 {width: calc(100% - 395px);float: left;background-color: #fff;height: 178px;}
.Setdepartment-top1 li {width: calc(100% / 6);float: left;}
.Setdepartment-top1 li p {font-size: 18px;margin-top: 16px;margin-left: 16px;}
.Setdepartment-top2 {width: 380px;float: right;height: 339px;background-color: #fff;}
.Setdepartment-top2 div {margin-top: 10px;float: left;}
.Setdepartment-top2 ul {margin-top: 10px;float: right;width: 120px;}
.Setdepartment-top2 ul li {margin-top: 20px;}
.Setdepartment-top2 ul i {width: 10px;height: 10px;border-radius: 50%;background-color: #000;display: inline-block;}
.Setdepartment-top2 ul span {margin-left: 4px;}
.Setdepartment-top2 ul em {font-style: normal;margin-top: 4px;display: inline-block;}
.Setdepartment-top3 {height: 147px;background: rgba(255, 255, 255, 1);width: calc(100% - 395px);float: left;margin-top: 15px;}
.Setdepartment-top4 {width: calc(100% - 395px);float: left;background-color: #fff;margin-top: 15px;height: calc(100% - 365px);overflow: auto;}
.Setdepartment-top4left {width: 560px;height: 231px;background: #fff;float: left;margin-top: 20px;margin-left: 16px;}
.Setdepartment-top4right {width: 234px;height: 231px;background: #fff;float: right;margin-top: 20px;}
.Setdepartment-top4 h2 {width: 70%;float: left;}
.Setdepartment-top4 .cdsnhli > span {float: right; margin-top: 16px; margin-right: 16px; height: 42px;}
.Setdepartment-top4 li {width: 24%;height: 89px;float: left;text-align: left;}
.Setdepartment-top4 li span {margin-left: 16px;color: rgba(141, 141, 141, 1);font-size: 16px;}
.Setdepartment-top4 li p {margin-left: 16px;color: rgba(92, 92, 92, 1);font-size: 18px;margin-top: 10px;}
.Setdepartment-top4 h3 {margin-top: 10px;}
.Setdepartment-top5 {width: 380px;float: right;background-color: #fff;margin-top: 15px;height: calc(100% - 365px);overflow: auto;}
.Setdepartment-top5 ul {margin-top: 10px;}
.Setdepartment-top5 li {width: 49.5%;float: left;height: 110px;text-align: center;margin: auto;cursor: pointer;}
.Setdepartment-top5 li div {width: 40px;height: 40px;background: linear-gradient(135deg,rgba(255, 195, 80, 1) 0%,rgba(242, 158, 0, 1) 100%);border-radius: 8px;mix-blend-mode: normal;font-size: 26px;line-height: 40px;text-align: center;color: #fff;position: relative;margin-top: 16px;}
.Setdepartment-top3 li {width: calc(100% / 6);float: left;text-align: center;margin-top: -4px;}
.Setdepartment-top3 li div {width: 48px;height: 48px;background: linear-gradient(135deg,rgba(255, 195, 80, 1) 0%,rgba(242, 158, 0, 1) 100%);border-radius: 8px;
mix-blend-mode: normal;font-size: 26px;line-height: 48px;text-align: center;color: #fff;position: relative;margin-top: -4px;margin: auto;}
.Setdepartment-top3 li p {font-size: 16px;margin-top: 15px;}
.Setdepartment-top5 li p {font-size: 16px;margin-top: 15px;}
.Setdepartment-top5 li i {position: absolute;top: -10px;right: -10px;background-color: red;height: 20px;width: 20px;border-radius: 50%;font-size: 12px;line-height: 20px;}
.Setdepartment-top5 li:nth-child(1) {border-right: 1px solid #c5c5c5;}
.Setdepartment-top5 li:nth-child(3) {border: 1px solid #c5c5c5;border-left: none;}
.Setdepartment-top5 li:nth-child(4) {border: 1px solid #c5c5c5;border-right: none;border-left: none;}
.Setdepartment-top5 li:nth-child(5) {border-right: 1px solid #c5c5c5;}
.cdsnhli {height: 60px;}
</style>
